import { Component, Input } from '@angular/core';
import { TreeCommandsHandler } from '../../tree/tree-commands-handler';
import { NodeSelectionHandler } from '../../tree/node-selection-handler';
import { TreeUtils } from '../../tree/tree-utils';
import { MaterialTree } from '../../models/material-tree';


@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'group-toolbar',
  templateUrl: './group-toolbar.component.html',
  styleUrls: ['./group-toolbar.component.css']
})
export class GroupToolbarComponent {
  @Input() treeCommandsHandler: TreeCommandsHandler;
  @Input() nodeSelectionHandler: NodeSelectionHandler;
  @Input() treeUtils: TreeUtils;
  @Input() visibleSelectAllButton: boolean;
  @Input() node;
  @Input() materialTree: MaterialTree;
  @Input() status: string;
}
